const user_management = {
  title: 'コーチ情報詳細',
  full_name_kanji: '氏名（漢字）',
  full_name_kana: '氏名（カナ）',
  date_of_birth: '生年月日',
  gender: '性別',
  email: 'メールアドレス',
  phone_number: '携帯番号 ',
  post_code: '郵便番号',
  address: '住所',
  graduation: '卒業期',
  plan: 'プラン',
  reject_button: '拒否',
  approve_button: '承認',
  approve_success: 'ご指定のアカウントを承認しました。',
  reject_success: 'ご指定のアカウントを拒否しました。',
  approve_confirm: {
    title: 'アカウント発行確認',
    content: 'ご指定のユーザーにシステムのアカウントを承認します。よろしいでしょうか。',
    cancel_button: 'キャンセル',
    confirm_button: 'はい',
  },
  reject_confirm: {
    title: 'アカウント発行確認',
    content: 'ご指定のユーザーにシステムアカウントの発行を拒否します。よろしいでしょうか。',
    cancel_button: 'キャンセル',
    confirm_button: 'はい',
  }
}

export default user_management;